import React, { FC } from "react";
import { ArticleTeaserViewModel } from "./ArticleTeaserViewModel.csharp";

interface ArticleTeaserProps extends ArticleTeaserViewModel {
  verticalLayout?: boolean;
}

export const ArticleTeaser: FC<ArticleTeaserProps> = ({
  url,
  imageUrl,
  heading,
  verticalLayout,
  listingImageAnchor,
}) => {
  let outerCssClasses =
    "edge-to-edge-sm card__column-alternation-md col-md-8 mb-1";
  let flexCssClasses = "d-flex";
  let innerSquareImageCssClasses = "card-inner-square position-relative";
  let innerSquareTextCssClasses = "card-inner-square";

  if (verticalLayout) {
    outerCssClasses = "edge-to-edge-sm-double-col col-9 col-sm-6 col-md-4 mb-1";
    flexCssClasses += " flex-column";
    innerSquareImageCssClasses += " card-inner-square-full";
    innerSquareTextCssClasses += " card-inner-square-full";
  }
  return (
    <div className={outerCssClasses}>
      <div className="card card-hover theme-inherit-light">
        <div className={flexCssClasses}>
          <div className={innerSquareImageCssClasses}>
            <img
              src={
                imageUrl + `?width=290&height=290&rmode=crop&ranchor=${listingImageAnchor}`
              }
              alt=""
              loading="lazy"
            />
          </div>
          <div className={innerSquareTextCssClasses}>
            <div className="card-inner-square__padding">
              <h2 className="h5 card-title">
                <a className="card-block-link" href={url}>
                  <span dangerouslySetInnerHTML={{ __html: heading.replace(/\|/g, '&shy;')}} />
                  <i className="icon icon-arrow-right"></i>
                </a>
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
